import { render } from "./DeclaracoesDocumentos.vue?vue&type=template&id=7faf9172&scoped=true"
import script from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"
export * from "./DeclaracoesDocumentos.vue?vue&type=script&lang=js"

import "./DeclaracoesDocumentos.vue?vue&type=style&index=0&id=7faf9172&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faf9172"]])

export default __exports__